import { render, staticRenderFns } from "./userStatistics.vue?vue&type=template&id=3bc223dc&scoped=true&"
import script from "./userStatistics.vue?vue&type=script&lang=ts&"
export * from "./userStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./userStatistics.vue?vue&type=style&index=0&id=3bc223dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc223dc",
  null
  
)

export default component.exports